module.exports = __webpack_public_path__ + "static/ux_8_2_eg-33d7d717de26fd016103a648cec1ea0c.png";